import {
  AccountConversationDataDetail,
  AccountConversationDataType,
  ChatBotInfoResponseTypes,
  ConversationResponseTypes,
  CreateConversationParamsTypes,
  DataConversationTypes,
  FeedbackConversationService,
  AiAssistantServiceTypes,
  ChatMessageTypes,
} from 'services/accountConversations/types';
import { AuthResTypes } from 'services/auth/types';
import axiosChatbotInstance from 'services/common/chatBotInstance';
import axiosInstance from 'services/common/instance';
import { getLocalStorage } from 'services/common/storage';
import { LOCAL_STORAGE_CHATBOT } from 'utils/constants';

export const verifyChatBotService = async (): Promise<AuthResTypes> => {
  const res = await axiosInstance.post('chat-bot/verify');
  return res.data.data;
};

export const verifyTestChatBotService = async (): Promise<AuthResTypes> => {
  const res = await axiosInstance.post('chat-bot/agent/verify');
  return res.data.data;
};

export const getChatBotInfoService = async (): Promise<ChatBotInfoResponseTypes> => {
  const res = await axiosChatbotInstance.get('chat-bot/info');
  return res.data.data;
};

export const sendOTPChatBotService = async (params: {
  phone: string;
}): Promise<{
  otp: string;
}> => {
  const res = await axiosChatbotInstance.post('chat-bot/account/send-otp', params);
  return res.data.data;
};

export const sendMailOTPChatBotService = async (params: {
  mail: string;
}): Promise<{
  otp: string;
}> => {
  const res = await axiosChatbotInstance.post('chat-bot/account/send-mail-otp', params);
  return res.data.data;
};

export const verifyOTPChatBotService = async (params: {
  phone?: string;
  mail?: string;
  otp: string;
}): Promise<AuthResTypes> => {
  const res = await axiosChatbotInstance.post('chat-bot/account/verify-otp', params);
  return res.data.data;
};

export const createConversationChatBotService = async (
  params: CreateConversationParamsTypes
): Promise<ConversationResponseTypes> => {
  const res = await axiosChatbotInstance.post('account-conversations', params);
  return res.data.data;
};

export const getConversationsChatBotService = async (
  code: string,
  params: RequestParamsTypes
): Promise<APIPaginationResponse<DataConversationTypes[]>> => {
  const res = await axiosChatbotInstance.get(`account-conversations/${code}/items`, { params });
  return res.data;
};

export const getAccountConversationsService = async (
  params: RequestParamsTypes
): Promise<APIPagination<AccountConversationDataType[]>> => {
  const res = await axiosChatbotInstance.get('account-conversations', { params });
  return res.data;
};

export const getAccountConversationByIdService = async (code: string)
  : Promise<AccountConversationDataDetail> => {
  const res = await axiosChatbotInstance.get(`account-conversations/${code}`);
  return res.data.data;
};

export const feedbackConversationService = async (
  conversationCode: string,
  code: string,
  params: FeedbackConversationService
): Promise<ConversationResponseTypes> => {
  const res = await axiosChatbotInstance.post(
    `account-conversations/${conversationCode}/items/${code}/feedback`,
    params
  );
  return res.data.data;
};

export const refreshTokenChatbotService = async (): Promise<AuthResTypes> => {
  const res = await axiosInstance.post('chat-bot/account/refresh-token', {
    refreshToken: getLocalStorage(LOCAL_STORAGE_CHATBOT.REFRESHTOKEN_CHATBOT),
  });
  return res.data.data;
};

export const deleteItemConversationChatBotService = async (params: {
  conversationCode: string;
  code: string;
}): Promise<AuthResTypes> => {
  const res = await axiosChatbotInstance.delete(
    `account-conversations/${params.conversationCode}/items/${params.code}`
  );
  return res.data;
};

export const deleteFileConversationChatBotService = async (
  code: string,
  params: {
    codes: string[];
  }
): Promise<void> => {
  const res = await axiosChatbotInstance.delete(`account-conversations/${code}/files`, { data: params });
  return res.data;
};

export const getAiAssistantService = async (code: string): Promise<AiAssistantServiceTypes[]> => {
  const res = await axiosChatbotInstance.get(`account-conversations/${code}/ai-assistant-services`);
  return res.data.data;
};

export const getTokenSocketService = async (): Promise<string> => {
  const res = await axiosChatbotInstance.post('websocket/chat/generate-token');
  return res.data.data?.token;
};

export const wsSendChatService = async (code: string, params: ChatMessageTypes): Promise<any> => {
  const res = await axiosChatbotInstance.post(`account-conversations/${code}/ws-chat`, params);
  return res.data.data;
};
